import React, {useEffect} from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Route, Routes, Navigate, useNavigate, useLocation } from 'react-router-dom';
import routes from '../config/routes';
import { IState } from '../interfaces/redux';
import "react-datepicker/dist/react-datepicker.css";
import logout from '../_helper/_logout';
import OfflineDetect from '../components/_helper/offline-detect';
import { useTranslation } from 'react-i18next';
import PWAModal from '../components/_helper/pwa-ios-modal';
import VersionChecker from '../components/version-checker/VersionChecker';
import Home from './home.page';
import dashboard_routes from '../config/dashboard_routes';
import { useMatomo } from '@datapunt/matomo-tracker-react';

const Application: React.FunctionComponent<{}> = props => {
    const { trackPageView } = useMatomo()

     const location = useLocation();
     useEffect(() => {
         const pathName = location.pathname;
         
         trackPageView({
             documentTitle: pathName, 
         })
         
     }, [location]);

    const { t } = useTranslation();

    const isAuthenticated: boolean = useSelector(
        (state: IState) => state.isAuthenticated,
        shallowEqual
    )

    const handleInvalidUserId = () => {
        if (!localStorage.getItem("userid") && window.location.pathname.includes("/dashboard")) {
            logout()
        }
      }

    useEffect(() => {
        window.addEventListener('storage', handleInvalidUserId);

        return function cleanup() {
          window.removeEventListener('storage', handleInvalidUserId);
        }
      }, []);

    /**
     * Main router components
     * 
     * get routes interface loop trough the implemented routes and create a component for each
     * 
     */
    return (
        <div className="App">
            <PWAModal />
            <OfflineDetect />
            <VersionChecker />
                <Routes>
                    {routes.map((route, index) => {
                        if (route.private) {
                            return (
                                <Route
                                    key={index}
                                    path={route.path}
                                    element={
                                        isAuthenticated
                                            ? <route.component {...route.props} />
                                            : <Navigate to="/login" replace />
                                    }
                                />
                            );
                        } else {
                            return (
                                <Route
                                    key={index}
                                    path={route.path}
                                    element={<route.component {...route.props} />}
                                />
                            );
                        }
                    })}
                    <Route
                        path="/dashboard"
                        element={<Navigate to="/dashboard/stories/1" replace />}
                    />                    
                    <Route path="/dashboard/*" element={<Home name=""/>}>
                        {dashboard_routes.map((route, index) => {
                            return (
                                <Route
                                key={index}
                                path={route.path}
                                element={
                                    route.private ? (
                                    isAuthenticated ? (
                                        <route.component {...route.props} />
                                    ) : (
                                        <Navigate to="/login" replace />
                                    )
                                    ) : (
                                    <route.component {...route.props} />
                                    )
                                }
                                />
                            );
                        })}
                    </Route>
                    <Route path="*" element={<p>{t("Not found")}</p>} />
                </Routes>
        </div>
    );
}

export default Application;
